import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './PaymentResult.css';
import api from '../../hooks/api';
import moment from 'moment-jalaali';

const PaymentResult = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isloading, setisLoading] = useState(false);
  const [price, setPrice] = useState(null);
  const [refId, setRefId] = useState(null);
  const [date, setDate] = useState(null);
  const [title, seTitle] = useState(null);

  const toPersianDigits = (num) => {
    if (num === null || num === undefined) return "";
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    return num.toString().replace(/\d/g, (d) => persianDigits[d]);
  };

  const status = searchParams.get('status');
  const key = searchParams.get('key');
  const page = searchParams.get('page');
  const payload = searchParams.get('payload');
  // const sign = searchParams.get('sign'); // در صورت نیاز به ارسال به بک‌اند

  const isSuccess = status === 'success';

  // 1. هندل کردن دکمه بازگشت بومی تلگرام در مینی‌اپ
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg && tg.initDataUnsafe) {
      tg.BackButton.show();

      const handleBack = () => {
        navigate('/Shop');
      };

      tg.onEvent('backButtonClicked', handleBack);

      return () => {
        tg.offEvent('backButtonClicked', handleBack);
        tg.BackButton.hide();
      };
    }
  }, [navigate]);

  // 2. دریافت اطلاعات تراکنش (از URL یا API)
  useEffect(() => {
    if (payload) {
      // دریافت دیتای Credit از URL از طریق دیکد کردن
      try {
        // استفاده از decodeURIComponent برای جلوگیری از به هم ریختن حروف فارسی
        const decodedString = decodeURIComponent(escape(atob(payload)));
        const decodedData = JSON.parse(decodedString);

        console.log("Decoded Payload:", decodedData);

        // نام کلیدها را با توجه به خروجی بک‌اند خود تنظیم کنید
        setPrice(decodedData.price || decodedData.amount);
        setRefId(decodedData.ref_id || decodedData.transaction_id);
        setDate(decodedData.getwayDate || decodedData.date);
        if (decodedData.title) {
          seTitle(decodedData.title);
        }
      } catch (e) {
        console.error("داده‌های Payload نامعتبر هستند.", e);
        // Fallback ساده در صورت خطا در دیکد حروف فارسی
        try {
          const decodedData = JSON.parse(atob(payload));
          setPrice(decodedData.price);
          setRefId(decodedData.ref_id);
          setDate(decodedData.getwayDate || decodedData.date);
          if (decodedData.title) seTitle(decodedData.title);
        } catch (err) {
          console.error("خطا در دیکد ساده:", err);
        }
      }
    } else if (key > 0 && isSuccess && page) {
      // درخواست API برای حالت‌هایی که Payload ندارند (مثل Invoice)
      setisLoading(true);

      let endpoint = '';
      let apiPayload = {};

      if (page === 'invoice') {
        endpoint = 'invoice/payment/result';
        apiPayload = { transaction_id: key };
      } else if (page === 'credit') {
        endpoint = 'credit/payment/result';
        apiPayload = { credit_id: key };
      } else {
        setisLoading(false);
        return;
      }

      api.post(endpoint, apiPayload)
        .then((response) => {
          if (response.data.success) {
            setPrice(response.data.data.price);
            setRefId(response.data.data.ref_id);
            setDate(response.data.data.getwayDate);
            if (response.data.data.title) {
              seTitle(response.data.data.title);
            }
          }
          setisLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setisLoading(false);
        });
    }
  }, [key, isSuccess, page, payload]);

  const formatPrice = (amount) => {
    if (!amount) return '0';
    return Number(amount).toLocaleString('fa-IR');
  };

  // 3. تابع بازگشت دستی
  const handleGoDashboard = () => {
    navigate('/StorePanelStation');
  };

  const handleShare = async () => {
    if (!isSuccess || isloading) return;

    const shareText = `
✅ *تراکنش موفق*
📌 بابت: ${title || 'خرید از فروشگاه'}
📅 تاریخ: ${date || '---'}
💰 مبلغ: ${formatPrice(price)} تومان
🔢 کد پیگیری: ${refId || '---'}
    `.trim();

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'رسید پرداخت',
          text: shareText,
          url: window.location.href,
        });
      } catch (err) {
        console.log('Share canceled or failed', err);
      }
    } else {
      navigator.clipboard.writeText(shareText);
      alert('متن رسید در کلیپ‌بورد کپی شد!');
    }
  };

  return (
    <div className="payment-container">
      <div className="receipt-card">

        {/* هدر کارت */}
        <div className="receipt-header">
          {isSuccess ? (
            <>
              <div className="icon-circle success-bg">
                <svg className="status-icon" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 13L9 17L19 7" />
                </svg>
              </div>
              <h2 className="status-text success-text">تراکنش موفق</h2>
              <p className="sub-status">پرداخت با موفقیت انجام شد</p>
              <div className="payment-title">
                {isloading ? <div className="skeleton skeleton-title"></div> : title}
              </div>
            </>
          ) : (
            <>
              <div className="icon-circle error-bg">
                <svg className="status-icon" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </div>
              <h2 className="status-text error-text">تراکنش ناموفق</h2>
              <p className="sub-status">متاسفانه پرداخت انجام نشد</p>
            </>
          )}
        </div>

        <div className="dashed-line"></div>

        {/* بدنه رسید */}
        {isSuccess ? (
          <div className="receipt-body">
            <div className="info-row">
              <span className="label">تاریخ تراکنش :</span>
              {isloading ? (
                <div className="skeleton skeleton-text"></div>
              ) : (
                <span className="value" style={{ textAlign: "right" }}>{date && toPersianDigits(moment(date).format('hh:mm - jYYYY-jMM-jDD'))}</span>
              )}
            </div>

            <div className="info-row">
              <span className="label">کد پیگیری :</span>
              {isloading ? (
                <div className="skeleton skeleton-text"></div>
              ) : (
                <span className="value">{toPersianDigits(refId)}</span>
              )}
            </div>

            {isloading ? (
              <div className="skeleton skeleton-box"></div>
            ) : (
              <div className="amount-box">
                <span>مبلغ :</span>
                <span className="amount-value">{toPersianDigits(formatPrice(price))} تومان</span>
              </div>
            )}
          </div>
        ) : (
          <div className="receipt-body error-body">
            <p>در صورت کسر وجه، مبلغ طی ۷۲ ساعت به حساب شما بازخواهد گشت.</p>
          </div>
        )}

        <div className="dashed-line"></div>

        {/* دکمه‌ها */}
        <div className="receipt-footer">
          <button onClick={handleGoDashboard} className="btn primary-btn" disabled={isloading}>
            {isSuccess ? 'بازگشت به سبد من' : 'بازگشت به فروشگاه'}
          </button>

          {isSuccess && (
            <button onClick={handleShare} className="btn outline-btn" disabled={isloading}>
              اشتراک‌ گذاری رسید
            </button>
          )}
        </div>

        <div className="jagged-edge"></div>
      </div>
    </div>
  );
};

export default PaymentResult;
